import Vue from 'vue';
import axios from 'axios'

//Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;
//Vue.use(require('vue-moment'));

Vue.prototype.$storeReglesBourse = {
    EstVide(valeur){
        if(valeur === undefined 
            || valeur === ''
            || valeur === null){
                return true
            }
        return false;
    },
    email:
    [
        v => !v || /.+@.+\..+/.test(v) || 'E-mail invalide',
    ],
    emailObligatoire: 
    [
        v => !!v || 'Champ obligatoire',
        v => /.+@.+\..+/.test(v) || 'Format email incorrect',
    ],
    obligatoire: 
    [
        v => !!v || 'Champ obligatoire',
    ],
    multiObligatoire: 
    [
        v => !!v || 'Champ obligatoire',
        v => (v && v.length > 0) || 'Champ obligatoire',
    ],
    telephone: [
        v => !v || /^(\+\d{1,4}\s?)?(\d{1,}[\s.-]?){8,}$/.test(v) || 'Format de téléphone incorrect',
    ],
    telephoneObligatoire: [
        v => !!v || 'Champ obligatoire',
        v => !v || /^(\+\d{1,4}\s?)?(\d{1,}[\s.-]?){8,}$/.test(v) || 'Format de téléphone incorrect',
    ],
    obligatoireLengthDix:
    [
        v => !!v || 'Champ obligatoire',
        v => (v && v.length < 10) || 'Veuillez saisir moins de 9 caractères',
    ],
    LengthDix:
    [
        v=> !v || v.length < 10 || "9 caractères maximum" 
    ],
    EstNumerique:
    [
        v => !v || !isNaN(v.toString().replace(",",".")) || 'Veuillez renseigner un numérique'
    ],
    EstNumeriqueObligatoire:
    [
        v => !!v || 'Champ obligatoire',
        v => !v || !isNaN(v.toString().replace(",",".")) || 'Veuillez renseigner un numérique'
    ],
    EstNumeriqueObligatoire0:
    [
        v => !!v || 'Champ obligatoire',
        v => !isNaN(v.toString().replace(",", ".")) || 'Veuillez renseigner un numérique',
        v => parseFloat(v.toString().replace(",", ".")) > 0 || 'Renseigner un montant supérieur à 0',
    ],
    NumObli:{
        EstNumeriqueObligatoire0(montant)
        {
            if (!montant) return 'Champ obligatoire';
            if (!isNaN(montant.toString().replace(",",".")) && montant.toString().replace(",",".") > 0) return true;
            return 'Renseigner un montant supérieur à 0';
        },
    },
    TailleBic:
    [
        v=> !v || v.length == 8 || v.length == 11 || "Longueur du BIC incorrect (8 ou 11 caractères)" 
    ],
    CompteMarocain:
    [
        v => /^[0-9]{24}$/.test(v) || "Le numéro de compte doit être de 24 chiffres.",
    ],
    AgeMinimumCandidat:
    {
        ageMinimum: (value) => {
        if (!value) return true;
        const [day, month, year] = value.split('/');
        const datedeNaissance = new Date(year, month-1, day);
        const minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 13);
        return datedeNaissance <= minDate || "Le Candidat doit avoir au moins 13 ans.";
      },
    }
}


